import * as React from "react";

export const ColorModeContext = React.createContext({
  toggleColorMode: () => {},
});
